import Layout from '@/layout'
import ParentView from '@/components/ParentView'
const conferenceRoutes =
{
  path: '/oa/conference',
  component: Layout,
  redirect: 'noredirect',
  name: '会议室预定',
  funcPerms: 'oa:room',
  meta: {
    title: '会议室预定',
    icon: 'huiyishi',
    affix: false,
    noCache: true
  },
  children: [

    {
      path: 'conference/index',
      component: () => import('@/views/oa/conference/index.vue'),
      funcPerms: 'oa:room',
      name: 'huiyishi',
      meta: {
        title: '会议室预定',
        icon: 'huiyishi',
        affix: false,
        noCache: true
      }
    }

  ]
}

export default conferenceRoutes
